import createReactComponent from '../createReactComponent';
export default createReactComponent('home-search', 'IconHomeSearch', [
  ['path', { d: 'M21 12l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h4.7', key: 'svg-0' }],
  ['path', { d: 'M9 21v-6a2 2 0 0 1 2 -2h2', key: 'svg-1' }],
  ['path', { d: 'M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0', key: 'svg-2' }],
  ['path', { d: 'M20.2 20.2l1.8 1.8', key: 'svg-3' }],
]);
